module.exports = __webpack_public_path__ + "img/payment-success.59fd9643.png";